import React from "react";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
// import FormSingleInput from "./formSingleInput.component";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface formSpecialityProps {
  specialityAreas: { id: number; name: string }[];
  onInputChange: (event: SelectChangeEvent) => void;
  onInputChangeCustomSpeciality: React.ChangeEventHandler<HTMLInputElement>;
  selectSpeciality: { id?: number; value?: string };
  customSpeciality?: string;
}

const FormSpeciality: React.FC<formSpecialityProps> = ({
  specialityAreas,
  onInputChange,
  onInputChangeCustomSpeciality,
  selectSpeciality,
  customSpeciality,
}) => {
  return (
    <React.Fragment>
      <Box sx={{ marginTop: "15px" }}>
        <Box>
          <Typography
            sx={{
              letterSpacing: "0px",
              color: "#333333",
              opacity: 0.6,
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "15px", xl: "20px" },
              lineHeight: {
                xs: "20px",
                sm: "22px",
                md: "24px",
                xl: "27px",
              },
              marginBottom: "4px",
            }}
          >
            Please select all that apply
          </Typography>
          {Array.isArray(specialityAreas) && specialityAreas.length > 0 && (
            <FormControl
              sx={{
                marginBottom: { sm: "10px" },
                marginLeft: 0,
                width: { xs: "200px", sm: "234px", md: "234px" },
                height: { xs: "42px", sm: "46px", md: "50px" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #94949533",
                  },
                  "&:hover fieldset": {
                    border: "1px solid #94949533",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#94949533",
                  },
                  "&:hover": {
                    border: "1px solid #94949533",
                  },
                  fontFamily: "Avenir",
                  fontSize: {
                    xs: "14px",
                    sm: "16px",
                    md: "18px",
                    xl: "24px",
                  },
                  lineHeight: {
                    xs: "20px",
                    sm: "22px",
                    md: "26px",
                    xl: "33px",
                  },
                },
              }}
            >
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                displayEmpty
                multiple={false}
                value={
                  selectSpeciality.id === undefined
                    ? ""
                    : selectSpeciality.id.toString()
                }
                onChange={onInputChange}
                input={<OutlinedInput />}
                name={"speciality"}
                renderValue={(valueId) => {
                  if (valueId === "") {
                    return "Your speciality";
                  } else {
                    const renderValue = specialityAreas.filter(
                      (speciality) => speciality.id.toString() === valueId
                    )[0];
                    return renderValue.name;
                  }
                }}
                MenuProps={MenuProps}
                sx={{
                  border: "1px solid #94949533",
                  borderRadius: "4px",
                  width: {
                    xs: "320px",
                    sm: "320px",
                    md: "407px",
                    xl: "553px",
                  },
                  height: { xs: "45px", sm: "45px", md: "49px", xl: "60px" },
                }}
              >
                {specialityAreas.map((speciality, index) => (
                  <MenuItem key={speciality.id} value={speciality.id}>
                    <Checkbox
                      checked={
                        selectSpeciality.id === speciality.id ? true : false
                      }
                    />
                    <ListItemText
                      primary={speciality.name}
                      sx={{
                        "& .MuiTypography-root": {
                          fontFamily: "Avenir",
                          fontSize: {
                            xs: "14px",
                            sm: "15px",
                            md: "18px",
                            xl: "24px",
                          },
                          lineHeight: {
                            xs: "20px",
                            sm: "22px",
                            md: "26px",
                            xl: "33px",
                          },
                          letterSpacing: 0,
                          color: "#333333",
                          opacity: 1,
                          mb: 0,
                        },
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
        {/* This Not Include */}
        {/* <Box
          sx={{
            marginTop: { xs: "20px", md: "40px" },
          }}
        >
          <Typography
            sx={{
              letterSpacing: "0px",
              color: "#333333",
              opacity: 1,
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "15px", xl: "18px" },
              lineHeight: {
                xs: "18px",
                sm: "20px",
                md: "22px",
                xl: "24px",
              },
            }}
          >
            Can’t find your specialisation on the list? Enter it below
          </Typography>
          <FormSingleInput
            value={customSpeciality}
            onInputChange={onInputChangeCustomSpeciality}
            placeholder={"Custom specialization"}
          />
        </Box> */}
      </Box>
    </React.Fragment>
  );
};

export default FormSpeciality;
